import styled from 'styled-components';

import { NumberInput } from '@dreryk/react-components';

export const StyledTreatmentDays = styled(NumberInput)`
   width: 77px;
`;
StyledTreatmentDays.displayName = 'StyledTreatmentDays';
